import {
  type DefineFindingDefinitionInput,
  findingContentToDomain,
  type ReviseFindingDefinitionInput,
} from "@repo/api/schemas";
import { FindingDefinition } from "@repo/domain";
import { deriveFindingDefinitionFields } from "../fhir/collections";
import { readFindingDefinitionRow, writeFindingDefinitionRow } from "../fhir/finding-definition-storage";
import type { FindingDefinitionRow } from "../fhir/types";

function row(
  input: DefineFindingDefinitionInput | ReviseFindingDefinitionInput,
  mintedAt: string,
  prior?: FindingDefinitionRow,
): FindingDefinitionRow {
  const previous = prior ? readFindingDefinitionRow(prior) : undefined;
  const definition = previous
    ? new FindingDefinition(previous).revise({ mintedAt, expectedVersion: previous.spine.version, versionTaken: false })
    : new FindingDefinition({
        spine: {
          url: input.definitionUrl,
          name: (input as DefineFindingDefinitionInput).name,
          description: (input as DefineFindingDefinitionInput).description,
          version: 1,
          availability: "Active",
          mintedAt,
        },
        ...findingContentToDomain(input),
      });
  if (previous) definition.setContent(findingContentToDomain(input));
  const facts = definition.facts;
  const resource = writeFindingDefinitionRow(facts, null);
  return {
    ...resource,
    id: `optimistic-finding-${input.definitionUrl}-${facts.spine.version}`,
    ...deriveFindingDefinitionFields(resource),
  };
}
export function optimisticDefinedFinding(input: DefineFindingDefinitionInput, mintedAt: string) {
  return row(input, mintedAt);
}
export function optimisticRevisedFinding(
  prior: FindingDefinitionRow,
  input: ReviseFindingDefinitionInput,
  mintedAt: string,
) {
  return row(input, mintedAt, prior);
}
